import { Radio as MUIRadio, RadioProps } from '@mui/material';
import { memo } from 'react';
import RadioCheckedIcon from '../../icons/RadioCheckedIcon';
import RadioIcon from '../../icons/RadioIcon';

export { default as RadioGroup } from './components/DefaultRadioGroup';
export { default as ReactHookFormRadioGroup } from './components/ReactHookFormRadioGroup';

const Radio = (props: RadioProps) => {
  const { disabled } = props;

  return (
    <MUIRadio
      checkedIcon={<RadioCheckedIcon disabled={disabled} />}
      icon={<RadioIcon disabled={disabled} />}
      {...props}
    />
  );
};

export default memo(Radio);
